import * as yup from "yup";

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

export const createTeacherSchema = yup.object().shape({
  firstName: yup.string().required("Firstname is required"),
  lastName: yup.string().required("Lastname is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().min(6).required("Password is required"),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Phone number is required"),
  cnic: yup.number().required("CNIC is required"),
  qualification: yup.string().required("Qualification is required"),
  profilePicture: yup
    .mixed()
    .required("Profile Picture is required")
    .test(
      "fileSize",
      "File Size is too large",
      (value) => value && value.size <= 1024 * 1024
    )
    .test(
      "fileFormat",
      "Unsupported Format",
      (value) =>
        value &&
        ["image/jpeg", "image/png", "image/jpg", "image/svg"].includes(
          value.type
        )
    ),
});

export const loginTeacherSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.number().min(13).required("Password is required"),
});
